import React from 'react'

function Equal() {
  return (
    <div className='equal'>=</div>
  )
}

export default Equal